import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=ade40ca2&scoped=true&"
import script from "./activityList.vue?vue&type=script&lang=js&"
export * from "./activityList.vue?vue&type=script&lang=js&"
import style0 from "./activityList.vue?vue&type=style&index=0&id=ade40ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade40ca2",
  null
  
)

export default component.exports